import { render, staticRenderFns } from "./OrderDetailsPDF.vue?vue&type=template&id=08e3b8f8&scoped=true"
import script from "./OrderDetailsPDF.vue?vue&type=script&lang=js"
export * from "./OrderDetailsPDF.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsPDF.vue?vue&type=style&index=0&id=08e3b8f8&prod&lang=scss&scoped=true"
import style1 from "./OrderDetailsPDF.vue?vue&type=style&index=1&id=08e3b8f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3b8f8",
  null
  
)

export default component.exports